import { ReactComponent as CloseIcon } from '../../../../icons/select/Close4.svg'
import styles from './CloseIndicator.module.scss'
import { components } from 'react-select'
import React from 'react'

const ClearIndicator = (props) => (
  <components.ClearIndicator {...props}>
    <CloseIcon className={styles['custom-icon']} />
  </components.ClearIndicator>
)

export { ClearIndicator }
